import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { CobrancaPesquisaComponent } from './cobranca-pesquisa.component';
import { CobrancaDetalheComponent } from './cobranca-detalhe.component';
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { DominiosResolver } from 'src/app/shared/resolvers/dominios.resolver';

const routes: Routes = [
  {
    path: 'cobrancas/pesquisa',
    component: CobrancaPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
    	agentes: AgenteFinanceiroResolver,
    	dominios: DominiosResolver
    }, 
    data: { canReuse: false }
  },
  {
    path: 'cobrancas/:id',
    component: CobrancaDetalheComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CobrancaRoutingModule { }
